<template>
  <div class="content-section active" id="system-settings">
    <div class="admin-header">
      <div>
        <h1 class="admin-title">系统设置</h1>
        <p>配置系统参数和功能选项</p>
      </div>
      <div class="admin-actions">
        <button class="admin-btn" @click="saveSettings">
          <i class="fas fa-save"></i> 保存设置
        </button>
      </div>
    </div>
    
    <div class="settings-container">
      <div class="setting-card">
        <div class="setting-header">
          <i class="fas fa-bell"></i>
          <h3>通知设置</h3>
        </div>
        <div class="setting-option">
          <label>新预约通知</label>
          <label class="switch">
            <input type="checkbox" v-model="settings.notifications.enabled">
            <span class="slider"></span>
          </label>
        </div>
        <div class="setting-option">
          <label>通知方式</label>
          <select v-model="settings.notifications.method">
            <option value="internal">站内消息</option>
            <option value="email">电子邮件</option>
          </select>
        </div>
        <div class="setting-option">
          <label>接收通知邮箱</label>
          <input type="email" v-model="settings.notifications.email">
        </div>
      </div>
      
      <!--<div class="setting-card">
        <div class="setting-header">
          <i class="fas fa-user-cog"></i>
          <h3>管理账户设置</h3>
        </div>
        <div class="setting-option">
          <label>用户名</label>
          <input type="text" v-model="settings.admin.username">
        </div>
        <div class="setting-option">
          <label>邮箱地址</label>
          <input type="email" v-model="settings.admin.email">
        </div>
        <div class="setting-option">
          <label>修改密码</label>
          <input type="password" placeholder="输入新密码..." v-model="settings.admin.newPassword">
        </div>
      </div>-->
      
      <!--<div class="setting-card">
        <div class="setting-header">
          <i class="fas fa-cog"></i>
          <h3>系统参数</h3>
        </div>
        <div class="setting-option">
          <label>默认每页显示条数</label>
          <select v-model="settings.system.pageSize">
            <option :value="10">10条</option>
            <option :value="20">20条</option>
            <option :value="50">50条</option>
            <option :value="100">100条</option>
          </select>
        </div>
        <div class="setting-option">
          <label>自动刷新间隔(分钟)</label>
          <input type="number" min="1" max="60" v-model="settings.system.refreshInterval">
        </div>
        <div class="setting-option">
          <label>数据保留天数</label>
          <input type="number" min="30" max="365" v-model="settings.system.dataRetention">
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import { jwtDecode } from 'jwt-decode';

    export default {
        name: 'SystemSettings',
        data() {
            return {
                settings: {
                    notifications: {
                        enabled: true,
                        method: 'email',
                        email: ''
                    },
                    admin: {
                        username: 'admin',
                        email: 'support@shixinai.com',
                        newPassword: ''
                    },
                    system: {
                        pageSize: 10,
                        refreshInterval: 5,
                        dataRetention: 90
                    }
                }
            }
        },
        created() {
            this.getUserInfo();
        },
        methods: {
            checkToken() {
                const token = localStorage.getItem('token');
                if (token) {
                    try {
                        const decodedToken = jwtDecode(token);
                        const currentTime = Date.now() / 1000; // 当前时间的秒数

                        if (decodedToken.exp > currentTime) {
                            return true;
                        } else {
                            // Token 已过期，清除本地存储
                            localStorage.removeItem('token');
                            return false;
                        }
                    } catch (error) {
                        console.error('Token 解析失败或用户信息查询失败:', error);
                        localStorage.removeItem('token');
                        return false;
                    }
                    //todo 自动退出
                }
            },
            async getUserInfo() {
                if (!this.checkToken()) {
                    return;
                }
                const token = localStorage.getItem('token');
                const decodedToken = jwtDecode(token);
                try {
                    const response = await axios.get(`/api/users/${decodedToken.user_id}`, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.type == "error") {
                        this.$message({
                            message: "获取信息失败，请刷新",
                            type: "error",
                        });
                        return;
                    }

                    console.log(response.data);
                    this.settings.notifications.enabled = response.data.isOpenNotify == 0 ? false : true;
                    this.settings.notifications.method = response.data.notify == 0 ? 'internal' : 'email';
                    this.settings.notifications.email = response.data.email;

                } catch (error) {
                    console.error('update failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                }
            },
            async saveSettings() {
                if (this.settings.notifications.enabled && this.settings.notifications.method === 'email') {
                    // Validate email format
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailRegex.test(this.settings.notifications.email)) {
                        alert('请输入有效的邮箱地址');
                        return;
                    }
                }
                if (!this.checkToken()) {
                    this.$message({
                        message: "登录已过期，请退出重新登录",
                        type: "error",
                    });
                    return;
                }
                const token = localStorage.getItem('token');

                try {
                    const payload = {
                        enabled: this.settings.notifications.enabled === true ? 1 : 0,
                        method: this.settings.notifications.method === 'internal' ? 0 : 1,
                        email: this.settings.notifications.email
                    };
                    const response = await axios.post('/api/update_notify', payload, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });

                    if (response.status !== 200) {
                        this.$message({
                            message: "网络异常，请稍后尝试",
                            type: "error",
                        });
                        console.error(response.status);
                        return;
                    }
                    if (response.data.code !== "00") {
                        this.$message({
                            message: response.data.message,
                            type: "error",
                        });
                        return;
                    }

                    console.log(response.data);

                } catch (error) {
                    console.error('update failed:', error);
                    this.$message({
                        message: "网络异常，请稍后尝试",
                        type: "error",
                    });
                }
            }
        }
    }
</script>